
namespace Gamification.Gamification {

    enum AmbitoEnum {
        Indefinito = 0,
        VisualizzaChecklist = 1,
        VisualizzaNodi = 2
    }

    @Serenity.Decorators.registerEditor('Gamification.Gamification.ChecklistNodi2Editor')
    export class ChecklistNodi2Editor extends Serenity.EntityGrid<ChecklistNodiRow, any> {
        protected getColumnsKey() { return ChecklistNodiColumns.columnsKey; }
        protected getDialogType() { return ChecklistNodiDialog; }
        protected getIdProperty() { return ChecklistNodiRow.idProperty; }
        protected getInsertPermission() { return ChecklistNodiRow.insertPermission; }
        protected getLocalTextPrefix() { return ChecklistNodiRow.localTextPrefix; }
        protected getService() { return ChecklistNodiService.baseUrl; }

        static AmbitoEnum = AmbitoEnum;
        private selectedItem: ChecklistNodiRow = null;
        private selectedRowIndex: number = null;

        constructor(container: JQuery) {
            super(container);
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 100;
            return opt;
        }

        protected getInitialTitle() {
            return null;
        }

        protected usePager() {
            return true;
        }

        protected createQuickSearchInput() { }

        protected getGridCanLoad() {
            return this.idNodo != null || this.idChecklist != null;
        }

        protected getColumns() {
            var columns = super.getColumns();

            // Add column
            columns.unshift({
                field: 'Edit Row',
                name: '',
                format: ctx => '<a class="inline-action edit-row" title="Associa sostanze">' +
                    '<i class="fa fa-wrench text-blue"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            // Add column
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            // Remove Button
            //buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);

            //Add a Button
            buttons.push({
                title: 'Seleziona',
                hint: '',
                cssClass: 'goto-seleziona',
                icon: 'fa-list-ol',
                separator: true,
                onClick: () => { /*Add Function Here */
                    if (this.ambito == AmbitoEnum.VisualizzaNodi ) {

                        var nodiPickerDialog = new NodiPickerDialog({
                            hideNodi: this.view.getItems().map(x => x.IdChecklist)
                        });

                        nodiPickerDialog.onSuccess = (selected) => {
                            selected = selected.filter(x => !Q.any(this.view.getItems(), y => y.IdNodo == x.IdNodo));

                            //
                            var ordinali = this.view.getItems().map(x => x.IdNodoProgressivo);
                            var ordine = 0;
                            if (ordinali.length > 0)
                                ordine = Math.max(...ordinali);

                               //
                            for (var sel of selected) {
                                var item = <ChecklistNodiRow>{
                                    IdChecklist: this.idChecklist,
                                    IdNodo: sel.IdNodo,
                                    IdNodoNome: sel.Nome,
                                    IdNodoProgressivo: ordine,  
                                };

                                ChecklistNodiService.Create({
                                    Entity: item
                                },
                                    response => {
                                        this.view.addItem({
                                            IdChecklistNodo: response.EntityId,
                                            IdChecklist: this.idChecklist,
                                            IdNodo: sel.IdNodo,
                                            IdNodoNome: sel.Nome,
                                            IdNodoProgressivo: ordine
                                        });
                                        //
                                        this.refresh();
                                    },
                                    {
                                        async: false
                                    });
                            }

                            return true;
                        };

                        nodiPickerDialog.dialogOpen();
                    }
                }
            });

            //Add a Button
            buttons.push({
                title: 'Sposta su',
                hint: 'Sposta su',
                cssClass: 'decrementa-ordine',
                icon: 'fa-arrow-up',
                separator: true,
                onClick: () => { /*Add Function Here */
                    if (this.selectedRowIndex != null) {
                        if (this.selectedRowIndex > 0) {
                            //
                            var itemSelezionato = this.itemAt(this.selectedRowIndex);
                            var itemPrecedente = this.itemAt(this.selectedRowIndex - 1);
                            //
                            if (itemSelezionato.IdNodoProgressivo !== itemPrecedente.IdNodoProgressivo) {
                                var ordineSelezionato = itemSelezionato.IdNodoProgressivo;
                                var ordinePrecedente = itemPrecedente.IdNodoProgressivo;

                                itemSelezionato.IdNodoProgressivo = ordinePrecedente;
                                itemPrecedente.IdNodoProgressivo = ordineSelezionato;
                            }

                            //
                            this.view.beginUpdate();
                            this.view.sortedUpdateItem(itemSelezionato.IdChecklistNodo, itemSelezionato);
                            this.view.sortedUpdateItem(itemPrecedente.IdChecklistNodo, itemPrecedente);
                            this.view.endUpdate();
                            this.view.reSort();
                            //
                            var selectedRows = this.slickGrid.getSelectedRows();
                            this.selectedRowIndex = this.selectedRowIndex - 1;
                            selectedRows[0] = this.selectedRowIndex;
                            this.slickGrid.setSelectedRows(selectedRows);
                            this.slickGrid.flashCell(this.selectedRowIndex, 1, 500);
                            this.slickGrid.setActiveCell(this.selectedRowIndex, 1);
                        }
                    }
                    else {
                        Q.notifyWarning("Selezionare il modulo che si desidera gestire.");
                    }
                }
            });

            //Add a Button
            buttons.push({
                title: 'Sposta giù',
                hint: 'Sposta giù',
                cssClass: 'incrementa-ordine',
                icon: 'fa-arrow-down',
                separator: true,
                onClick: () => { /*Add Function Here */
                    if (this.selectedRowIndex != null) {
                        if (this.selectedRowIndex < this.getItems().length - 1) {
                            //
                            var itemSelezionato = this.itemAt(this.selectedRowIndex);
                            var itemSuccessivo = this.itemAt(this.selectedRowIndex + 1);
                            //
                            if (itemSelezionato.IdNodoProgressivo !== itemSuccessivo.IdNodoProgressivo) {
                                var ordineSelezionato = itemSelezionato.IdNodoProgressivo;
                                var ordineSuccessivo = itemSuccessivo.IdNodoProgressivo;

                                itemSelezionato.IdNodoProgressivo = ordineSuccessivo;
                                itemSuccessivo.IdNodoProgressivo = ordineSelezionato;
                            }

                            //
                            this.view.beginUpdate();
                            this.view.sortedUpdateItem(itemSelezionato.IdChecklistNodo, itemSelezionato);
                            this.view.sortedUpdateItem(itemSuccessivo.IdChecklistNodo, itemSuccessivo);
                            this.view.endUpdate();
                            this.view.reSort();
                            //
                            var selectedRows = this.slickGrid.getSelectedRows();
                            this.selectedRowIndex = this.selectedRowIndex + 1;
                            selectedRows[0] = this.selectedRowIndex;
                            this.slickGrid.setSelectedRows(selectedRows);
                            this.slickGrid.flashCell(this.selectedRowIndex, 1, 500);
                            this.slickGrid.setActiveCell(this.selectedRowIndex, 1);
                        }
                    }
                    else {
                        Q.notifyWarning("Selezionare il modulo che si desidera gestire.");
                    }
                }
            });

            //
            return buttons;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented())
                return;

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Desideri eliminare il record selezionato?', () => {
                        ChecklistNodiService.Delete({
                            EntityId: item.IdChecklistNodo
                        },
                            response => {
                                this.view.deleteItem(item.IdChecklistNodo);
                                this.refresh();
                            },
                            { async: false });
                    });
                }

                if (target.hasClass("checklist-link")) {
                    e.preventDefault();
                    //
                    new Gamification.ChecklistDialog().loadByIdAndOpenDialog(item.IdChecklist);
                }
                else if (target.hasClass("nodo-link")) {
                    e.preventDefault();
                    //
                    new Gamification.NodiDialog().loadByIdAndOpenDialog(item.IdNodo);
                }
            }

            this.selectedItem = item;
            this.selectedRowIndex = row;
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        private _ambito: AmbitoEnum = AmbitoEnum.Indefinito;
        private _idNodo: number;
        private _idChecklist: number;

        // +++++++++++++++++++++++++++++++++++++++++++
        get ambito() {
            return this._ambito;
        }

        set ambito(value: AmbitoEnum) {
            if (this._ambito != value) {
                this._ambito = value;

                if (this._ambito == AmbitoEnum.VisualizzaChecklist) {
                    var columns = this.slickGrid.getColumns();

                    //var nIndice = Q.indexOf(columns, x => x.field == ChecklistNodiRow.Fields.IdChecklistNome);
                    //columns.splice(nIndice, 1);

                    //nIndice = Q.indexOf(columns, x => x.field == ChecklistNodiRow.Fields.UnitaNome);
                    //columns.splice(nIndice, 1);

                    this.slickGrid.setColumns(columns);
                }

                if (this._ambito == AmbitoEnum.VisualizzaNodi) {
                    var columns = this.slickGrid.getColumns();

                    //var nIndice = Q.indexOf(columns, x => x.field == ChecklistNodiRow.Fields.IdNodoTitolo);
                    //columns.splice(nIndice, 1);

                    this.slickGrid.setColumns(columns);
                }
            }
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        get idChecklist() {
            return this._idChecklist;
        }

        set idChecklist(value: number) {
            if (this._idChecklist != value) {
                this._idChecklist = value;
                this.setEquality(ChecklistNodiRow.Fields.IdChecklist, value);
                this.refresh();
            }
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        get idNodo() {
            return this._idNodo;
        }

        set idNodo(value: number) {
            if (this._idNodo != value) {
                this._idNodo = value;
                this.setEquality(ChecklistNodiRow.Fields.IdNodo, value);
                this.refresh();
            }
        }
    }
}